module.exports = __webpack_public_path__ + "img/55.751093e2.svg";